import { defineStore } from "pinia";
import { services } from "~/content/services";

export type ServicesState = {
  services: {
    records: { fields: Record<string, any> }[];
  };
  loading: boolean;
};

export const useServicesStore = defineStore("services", {
  state: () =>
    ({
      services: { records: services },
      loading: false,
    }) as ServicesState,

  getters: {
    getServicesForPrices(state) {
      return state.services.records.filter((r) => r.fields.forPrices === true);
    },
    getServicesForServices(state) {
      return state.services.records.filter((r) => r.fields.forServices === true);
    },
  },

  actions: {
    // Данные теперь статичны (в репозитории). Метод оставлен для обратной
    // совместимости с вызовом в pages/index.vue.
    fetchServices() {},
  },
});
